import { LegalLayout, LegalSection } from "../components/LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" updated="juin 2026" testId="legal-mentions-page">
      <LegalSection title="1. Éditeur du site">
        <p>
          Le site <strong>site.com</strong> est édité par <strong>site.com</strong>, entreprise immatriculée en France sous le numéro
          SIRET <strong>130 962 632 00019</strong>.
        </p>
        <p>Forme juridique : <strong>EI</strong> (entreprise individuelle)</p>
        <p>Siège social : <strong>5 Bis Chemin du Juge de Paix, 69130 Écully, France</strong></p>
        <p>
          Téléphone : <a href="tel:+33784678802" className="font-semibold text-navy hover:text-gold-dark">07 84 67 88 02</a> — Email :{" "}
          <a href="mailto:site.com@outlook.fr" className="font-semibold text-navy hover:text-gold-dark">site.com@outlook.fr</a>
        </p>
        <p>Numéro de TVA intracommunautaire : <strong data-testid="legal-vat-number">FR 78 130 962 632</strong></p>
      </LegalSection>

      <LegalSection title="2. Responsable de la publication">
        <p>
          <strong>Arthur Lefèvre</strong>, en qualité d'entrepreneur individuel exploitant site.com. Contact : site.com@outlook.fr.
        </p>
      </LegalSection>

      <LegalSection title="3. Hébergement">
        <p>
          Le présent site ainsi que les sites réalisés pour nos clients sont hébergés par <strong>OVHcloud</strong> — OVH SAS, 2 rue
          Kellermann, 59100 Roubaix, France — <a href="https://www.ovhcloud.com" target="_blank" rel="noreferrer" className="font-semibold text-navy hover:text-gold-dark">www.ovhcloud.com</a>.
        </p>
      </LegalSection>

      <LegalSection title="4. Propriété intellectuelle">
        <p>
          L'ensemble des contenus de ce site (textes, logo, visuels, structure) est la propriété de site.com ou de ses partenaires et est
          protégé par le Code de la propriété intellectuelle. Toute reproduction, représentation ou adaptation, totale ou partielle, sans
          autorisation écrite préalable est interdite.
        </p>
        <p>
          Les sites créés pour nos clients leur appartiennent intégralement (contenus, nom de domaine, code livré) à compter du paiement
          complet de la prestation.
        </p>
      </LegalSection>

      <LegalSection title="5. Prestations et paiement">
        <p>
          Les prix affichés sont indiqués en euros, nets. Les paiements en ligne sont sécurisés et traités par <strong>Stripe</strong>{" "}
          (Stripe Payments Europe Ltd., Dublin, Irlande) ; site.com ne stocke aucune donnée bancaire. L'abonnement Maintenance +
          Hébergement est sans engagement et résiliable à tout moment par simple email ; la résiliation prend effet à la fin de la période
          payée.
        </p>
      </LegalSection>

      <LegalSection title="6. Responsabilité">
        <p>
          site.com s'efforce de fournir des informations exactes et à jour mais ne saurait être tenu responsable des omissions, inexactitudes
          ou carences dans la mise à jour, ni des dommages résultant de l'accès ou de l'utilisation du site. Les liens vers des sites tiers
          n'engagent pas la responsabilité de site.com.
        </p>
      </LegalSection>

      <LegalSection title="7. Droit applicable">
        <p>
          Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut de résolution amiable, les
          tribunaux français compétents seront seuls saisis. Conformément aux articles L.611-1 et suivants du Code de la consommation, le
          consommateur peut recourir gratuitement au médiateur de la consommation désigné par site.com ; ses coordonnées sont communiquées
          sur simple demande écrite à site.com@outlook.fr.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
